









































































































































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {ReceiptExpensePickingList} from "@/interfaces/entity/receiptExpensePickingList";
import {ReceiptPaymentType} from "@/enums/type";
import {DebtPostOffice} from "@/interfaces/entity";
import moment from "moment";
import {FORMAT_DATE_TIME_PICKER} from "@/shared/constant";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {LadingStatus} from "@/enums/status";
import {ExpensePickingListStore} from "@/modules/receiptsexpenses/expensepickinglist/store";

@Component({
    name: "ExpensePostOfficePickingListPrint",
    components: {LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop({ type: Boolean, default: false }) readonly isPrint!: boolean;
    @Prop({ required: true }) readonly id!: any;

    ReceiptPaymentType = ReceiptPaymentType;
    LadingStatus = LadingStatus;
    moment = moment;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;
    get pickingList(): ReceiptExpensePickingList {
        return ExpensePickingListStore.data[this.id];
    }

    get debts(): Array<DebtPostOffice> {
        return this.getProp(this.pickingList, 'debtPostOffices', []);
    }

    get revenueExpenditureCreditor() {
        return this.debts[0]?.revenueExpenditureCreditor;
    }

    get totalReceiverCollect() {
        return this.debts.reduce((previousValue, currentValue) => {
            return previousValue + (currentValue.money || 0);
        }, 0);
    }
}
